(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const contractSchemaDefinition = require('../contract/schema-definition')
const required = require('@clocklimited/validity-required')

module.exports = function (config) {
  return schemata(Object.assign({}, contractSchemaDefinition(config).schema
  , { contractId:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , revisionDate:
      { type: Date
      , validators:
        { all: [ required ]
        }
      }
    , createdBy:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    }
  ))
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contract-revision/schema.js","/components/service/contract-revision")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9jb250cmFjdC1yZXZpc2lvbi9zY2hlbWEuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBzY2hlbWF0YSA9IHJlcXVpcmUoJ3NjaGVtYXRhJylcbmNvbnN0IGNvbnRyYWN0U2NoZW1hRGVmaW5pdGlvbiA9IHJlcXVpcmUoJy4uL2NvbnRyYWN0L3NjaGVtYS1kZWZpbml0aW9uJylcbmNvbnN0IHJlcXVpcmVkID0gcmVxdWlyZSgnQGNsb2NrbGltaXRlZC92YWxpZGl0eS1yZXF1aXJlZCcpXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKGNvbmZpZykge1xuICByZXR1cm4gc2NoZW1hdGEoT2JqZWN0LmFzc2lnbih7fSwgY29udHJhY3RTY2hlbWFEZWZpbml0aW9uKGNvbmZpZykuc2NoZW1hXG4gICwgeyBjb250cmFjdElkOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCByZXZpc2lvbkRhdGU6XG4gICAgICB7IHR5cGU6IERhdGVcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBjcmVhdGVkQnk6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgLCB2YWxpZGF0b3JzOlxuICAgICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gICkpXG59XG4iXX0=